import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';

const LogsPage = () => {
  const [activeTab, setActiveTab] = useState('whatsapp');
  const [whatsappLogs, setWhatsappLogs] = useState([]);
  const [systemMessageLogs, setSystemMessageLogs] = useState([]);
  const [firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [filters, setFilters] = useState({
    phone: '',
    status: 'all',
    firm_slug: 'all',
    date_filter: 'today'
  });
  const [resendingIds, setResendingIds] = useState(new Set());

  useEffect(() => {
    document.title = 'FBAJANS WhatsApp Business - Loglar';
    
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Firmaları yükle
  useEffect(() => {
    const loadFirms = async () => {
      try {
        const response = await fetch('https://panel.fbajans.com/api/firms');
        const data = await response.json();
        if (data.success) {
          setFirms(data.data || []);
        }
      } catch (error) {
        console.error('Firmalar yüklenemedi:', error);
      }
    };
    loadFirms();
  }, []);

  // Logları yükle
  useEffect(() => {
    loadLogs();
  }, [activeTab, currentPage, filters]);

  const loadLogs = async () => {
    setLoading(true);
    try {
      if (activeTab === 'whatsapp') {
        const params = new URLSearchParams({
          page: currentPage,
          limit: 20,
          phone: filters.phone,
          status: filters.status !== 'all' ? filters.status : '',
          firm_slug: filters.firm_slug !== 'all' ? filters.firm_slug : '',
          date_filter: filters.date_filter
        });

        const response = await fetch(`https://panel.fbajans.com/api/admin/whatsapp-logs?${params}`);
        const data = await response.json();
        
        if (data.success) {
          setWhatsappLogs(data.logs || []);
          setTotalPages(data.totalPages || 1);
          setTotal(data.total || 0);
        } else {
          setWhatsappLogs([]);
          setTotalPages(1);
          setTotal(0);
        }
      } else {
        const params = new URLSearchParams({
          page: currentPage,
          limit: 20,
          phone: filters.phone || '',
          date_filter: filters.date_filter
        });

        const response = await fetch(`https://panel.fbajans.com/api/admin/system-message-logs?${params}`);
        const data = await response.json();
        
        if (data.success) {
          setSystemMessageLogs(data.data.logs || []);
          setTotalPages(data.data.totalPages || 1);
          setTotal(data.data.total || 0);
        } else {
          setSystemMessageLogs([]);
          setTotalPages(1);
          setTotal(0);
        }
      }
    } catch (error) {
      console.error('Log yükleme hatası:', error);
      if (activeTab === 'whatsapp') {
        setWhatsappLogs([]);
      } else {
        setSystemMessageLogs([]);
      }
    }
    setLoading(false);
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({ phone: '', status: 'all', firm_slug: 'all', date_filter: 'today' });
    setCurrentPage(1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleResendMessage = async (logId) => {
    if (resendingIds.has(logId)) return;
    
    setResendingIds(prev => new Set(prev).add(logId));
    
    try {
      const response = await fetch(`https://panel.fbajans.com/api/admin/system-message-logs/${logId}/resend`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        alert('Mesaj başarıyla gönderildi!');
        loadLogs(); // Logları yenile
      } else {
        alert('Mesaj gönderilemedi: ' + (data.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Tekrar gönderme hatası:', error);
      alert('Mesaj gönderilemedi: ' + error.message);
    } finally {
      setResendingIds(prev => {
        const newSet = new Set(prev);
        newSet.delete(logId);
        return newSet;
      });
    }
  };

  const getStatusBadge = (status, logId = null, isSystemMessage = false) => {
    // Sistem mesajları için özel durum gösterimi
    if (isSystemMessage && activeTab === 'gpt') {
      if (status === 'sent' || status === 'success') {
        return <span style={{ 
          background: '#28a745', 
          color: 'white', 
          padding: '6px 12px', 
          borderRadius: '4px', 
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'default'
        }}><i className="fas fa-check-circle" style={{ marginRight: '4px' }}></i>Gönderildi</span>;
      } else if (status === 'failed' || status === 'error') {
        const isResending = logId && resendingIds.has(logId);
        return (
          <button
            onClick={() => !isResending && handleResendMessage(logId)}
            disabled={isResending}
            style={{ 
              background: isResending ? '#6c757d' : '#dc3545', 
              color: 'white', 
              padding: '6px 12px', 
              borderRadius: '4px', 
              fontSize: '12px',
              fontWeight: '600',
              border: 'none',
              cursor: isResending ? 'not-allowed' : 'pointer',
              transition: 'background 0.3s'
            }}
            onMouseEnter={(e) => {
              if (!isResending) e.target.style.background = '#c82333';
            }}
            onMouseLeave={(e) => {
              if (!isResending) e.target.style.background = '#dc3545';
            }}
          >
            {isResending ? (
              <>
                <i className="fas fa-spinner fa-spin" style={{ marginRight: '4px' }}></i>
                Gönderiliyor...
              </>
            ) : (
              <>
                <i className="fas fa-redo" style={{ marginRight: '4px' }}></i>
                Tekrar Gönder
              </>
            )}
          </button>
        );
      }
    }
    
    // Normal durum badge'leri
    switch (status) {
      case 'success':
      case 'sent':
        return <span style={{ 
          background: '#28a745', 
          color: 'white', 
          padding: '4px 8px', 
          borderRadius: '4px', 
          fontSize: '12px',
          fontWeight: '600'
        }}><i className="fas fa-check-circle" style={{ marginRight: '4px' }}></i>Başarılı</span>;
      case 'failed':
      case 'error':
        return <span style={{ 
          background: '#dc3545', 
          color: 'white', 
          padding: '4px 8px', 
          borderRadius: '4px', 
          fontSize: '12px',
          fontWeight: '600'
        }}><i className="fas fa-times-circle" style={{ marginRight: '4px' }}></i>Başarısız</span>;
      case 'pending':
        return <span style={{ 
          background: '#ffc107', 
          color: 'black', 
          padding: '4px 8px', 
          borderRadius: '4px', 
          fontSize: '12px',
          fontWeight: '600'
        }}>⏳ Bekliyor</span>;
      default:
        return <span style={{ 
          background: '#6c757d', 
          color: 'white', 
          padding: '4px 8px', 
          borderRadius: '4px', 
          fontSize: '12px',
          fontWeight: '600'
        }}>{status || '-'}</span>;
    }
  };

  const maskPhone = (phone) => {
    if (!phone) return '-';
    if (phone.length > 6) {
      return phone.slice(0, 3) + '***' + phone.slice(-2);
    }
    return phone;
  };

  const getMessageTypeBadge = (type) => {
    const typeConfig = {
      // Sistem Mesajları
      'application_received': { text: '📝 Başvuru Alındı', color: '#17a2b8', icon: '📝' },
      'application_approved': { text: '✅ Başvuru Onaylandı', color: '#28a745', icon: '✅' },
      'password_reset': { text: '🔑 Şifre Sıfırlama', color: '#dc3545', icon: '🔑' },
      // Lisans Hatırlatma Mesajları
      'license_reminder_7_days': { text: '⏰ Lisans Hatırlatma 7 Gün', color: '#ff9800', icon: '⏰' },
      'license_reminder_3_days': { text: '⏰ Lisans Hatırlatma 3 Gün', color: '#ff5722', icon: '⏰' },
      'license_reminder_0_days': { text: '⏰ Lisans Hatırlatma (Süresi Doldu)', color: '#dc3545', icon: '⏰' },
      // Normal Mesajlar (WhatsApp logları için)
      'order_status': { text: '📦 Sipariş', color: '#007bff' },
      'review_invite': { text: '⭐ Yorum', color: '#ffc107' },
      'abandoned_cart': { text: '🛒 Sepet', color: '#6c757d' },
      'bulk_message': { text: '📢 Toplu', color: '#6f42c1' },
      'new_order_customer': { text: '🛍️ Yeni Sipariş', color: '#007bff' },
      'order_status_change': { text: '🔄 Durum Değişti', color: '#17a2b8' },
      'new_member_customer': { text: '👤 Yeni Üye', color: '#28a745' },
      'new_member_admin': { text: '👥 Üye Bildirimi', color: '#6c757d' },
      'return_request': { text: '↩️ İade İsteği', color: '#ff9800' },
      'cargo_tracking': { text: '🚚 Kargo Takip', color: '#9c27b0' }
    };

    const config = typeConfig[type] || { text: type || '-', color: '#6c757d' };

    return <span style={{ 
      background: config.color, 
      color: 'white', 
      padding: '5px 10px', 
      borderRadius: '6px', 
      fontSize: '12px',
      fontWeight: '600',
      display: 'inline-block'
    }}>{config.text}</span>;
  };

  const currentLogs = activeTab === 'whatsapp' ? whatsappLogs : systemMessageLogs;

  return (
    <AdminLayout>
      <div style={{ padding: isMobile ? '15px' : '30px' }}>
        {/* Header */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '20px' : '0'
          }}>
            <div>
              <h1 style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '24px' : '32px', 
                fontWeight: '700',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                FBAJANS WhatsApp Business
              </h1>
              <p style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '500',
                color: '#555'
              }}>
                <i className="fas fa-clipboard-list" style={{ marginRight: '8px' }}></i>
                Loglar
              </p>
              {total > 0 && (
                <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#888' }}>
                  Toplam {total} kayıt bulundu
                </p>
              )}
            </div>
            <div style={{
              display: 'flex',
              gap: '15px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              {/* Tab Navigation */}
              <div style={{ display: 'flex', borderBottom: '2px solid #dee2e6', borderRadius: '8px 8px 0 0' }}>
                <button
                  onClick={() => {
                    setActiveTab('whatsapp');
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '12px 24px',
                    background: activeTab === 'whatsapp' ? '#007bff' : 'transparent',
                    color: activeTab === 'whatsapp' ? 'white' : '#333',
                    border: 'none',
                    borderBottom: activeTab === 'whatsapp' ? '3px solid #007bff' : '3px solid transparent',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    borderRadius: '8px 8px 0 0'
                  }}
                >
                  <i className="fas fa-mobile-alt" style={{ marginRight: '8px' }}></i>
                  WhatsApp Logları
                </button>
                <button
                  onClick={() => {
                    setActiveTab('gpt');
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '12px 24px',
                    background: activeTab === 'gpt' ? '#007bff' : 'transparent',
                    color: activeTab === 'gpt' ? 'white' : '#333',
                    border: 'none',
                    borderBottom: activeTab === 'gpt' ? '3px solid #007bff' : '3px solid transparent',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                    borderRadius: '8px 8px 0 0'
                  }}
                >
                  💬 Sistem Mesajları
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div style={{
          background: '#fff',
          padding: '25px',
          borderRadius: '12px',
          marginBottom: '20px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '15px',
            alignItems: 'end'
          }}>
            {activeTab === 'whatsapp' && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                  <i className="fas fa-phone" style={{ marginRight: '6px' }}></i>
                  Telefon Numarası
                </label>
                <input
                  type="text"
                  value={filters.phone}
                  onChange={(e) => handleFilterChange('phone', e.target.value)}
                  placeholder="Telefon numarası ara..."
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'border-color 0.3s',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            )}

            {activeTab === 'gpt' && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                  <i className="fas fa-phone" style={{ marginRight: '6px' }}></i>
                  Telefon Numarası
                </label>
                <input
                  type="text"
                  value={filters.phone}
                  onChange={(e) => handleFilterChange('phone', e.target.value)}
                  placeholder="Telefon numarası ara..."
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '2px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'border-color 0.3s',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            )}

            {activeTab === 'whatsapp' && (
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                  <i className="fas fa-info-circle" style={{ marginRight: '6px' }}></i>
                  Durum
                </label>
                <select
                  value={filters.status}
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: 'white',
                  cursor: 'pointer',
                  boxSizing: 'border-box'
                }}
                >
                  <option value="all">Tümü</option>
                  <option value="success">Başarılı</option>
                  <option value="failed">Başarısız</option>
                  <option value="pending">Bekliyor</option>
                </select>
              </div>
            )}

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#495057' }}>
                <i className="fas fa-calendar-alt" style={{ marginRight: '6px' }}></i>
                Tarih Aralığı
              </label>
              <select
                value={filters.date_filter}
                onChange={(e) => handleFilterChange('date_filter', e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  background: 'white',
                  cursor: 'pointer',
                  boxSizing: 'border-box'
                }}
              >
                <option value="all">Tüm Zamanlar</option>
                <option value="today">Bugün</option>
                <option value="yesterday">Dün</option>
                <option value="week">Son 7 Gün</option>
                <option value="month">Son 30 Gün</option>
              </select>
            </div>

            <div>
              <button
                onClick={clearFilters}
                style={{
                  width: '100%',
                  padding: '10px 16px',
                  background: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  transition: 'background 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#5a6268'}
                onMouseLeave={(e) => e.target.style.background = '#6c757d'}
              >
                <i className="fas fa-trash-alt" style={{ marginRight: '8px' }}></i>
                Filtreleri Temizle
              </button>
            </div>
          </div>
        </div>

        {loading && (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: '32px', color: '#007bff', marginRight: '12px' }}></i>
            <span style={{ fontSize: '16px', color: '#666' }}>Yükleniyor...</span>
          </div>
        )}

        {/* Logs Table */}
        {!loading && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                  <tr>
                    <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Tarih</th>
                    {activeTab === 'whatsapp' && (
                      <>
                        <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Firma</th>
                        <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Slug</th>
                        <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Telefon</th>
                      </>
                    )}
                    {activeTab === 'gpt' && (
                      <>
                        <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Telefon</th>
                        <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Mesaj Tipi</th>
                      </>
                    )}
                    <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Mesaj</th>
                    <th style={{ padding: '16px', textAlign: 'left', color: 'white', fontWeight: '600', fontSize: '14px' }}>Durum</th>
                  </tr>
                </thead>
                <tbody>
                  {currentLogs.map((log, index) => (
                    <tr key={index} style={{ 
                      borderBottom: '1px solid #f1f3f4',
                      transition: 'background 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                    >
                      <td style={{ padding: '15px', fontSize: '13px', color: '#495057' }}>
                        {formatDate(log.created_at || log.timestamp)}
                      </td>
                      {activeTab === 'whatsapp' && (
                        <>
                          <td style={{ padding: '15px' }}>
                            <div style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>
                              {log.firm_name || '-'}
                            </div>
                          </td>
                          <td style={{ padding: '15px' }}>
                            <div style={{ fontSize: '12px', color: '#666', fontFamily: 'monospace' }}>
                              {log.firm_slug || '-'}
                            </div>
                          </td>
                          <td style={{ padding: '15px', fontSize: '13px', color: '#495057', fontFamily: 'monospace' }}>
                            {log.phone || '-'}
                          </td>
                        </>
                      )}
                      {activeTab === 'gpt' && (
                        <>
                          <td style={{ padding: '15px', fontSize: '13px', color: '#495057', fontFamily: 'monospace' }}>
                            {log.phone || '-'}
                          </td>
                          <td style={{ padding: '15px' }}>
                            {getMessageTypeBadge(log.message_type)}
                          </td>
                        </>
                      )}
                      <td style={{ padding: '15px', maxWidth: '400px' }}>
                        <div style={{ 
                          overflow: 'hidden', 
                          textOverflow: 'ellipsis', 
                          whiteSpace: 'nowrap',
                          fontSize: '13px',
                          color: '#495057'
                        }} title={log.message || log.message_content || '-'}>
                          {log.message || log.message_content || '-'}
                        </div>
                      </td>
                      <td style={{ padding: '15px' }}>
                        {getStatusBadge(log.status, log.id, activeTab === 'gpt')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {currentLogs.length === 0 && !loading && (
              <div style={{ padding: '60px', textAlign: 'center', color: '#666' }}>
                <i className="fas fa-inbox" style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}></i>
                <p style={{ fontSize: '16px', margin: '0' }}>
                  {activeTab === 'whatsapp' ? 'WhatsApp logu bulunmuyor.' : 'Sistem mesaj logu bulunmuyor.'}
                </p>
              </div>
            )}
          </div>
        )}

        {/* Pagination */}
        {!loading && totalPages > 1 && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            gap: '15px', 
            marginTop: '30px' 
          }}>
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                padding: '10px 20px',
                background: currentPage === 1 ? '#e9ecef' : '#007bff',
                color: currentPage === 1 ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.3s'
              }}
            >
              <i className="fas fa-chevron-left" style={{ marginRight: '8px' }}></i>
              Önceki
            </button>
            
            <span style={{ 
              padding: '10px 20px', 
              background: '#f8f9fa', 
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#495057',
              border: '2px solid #dee2e6'
            }}>
              Sayfa {currentPage} / {totalPages}
            </span>
            
            <button
              onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                padding: '10px 20px',
                background: currentPage === totalPages ? '#e9ecef' : '#007bff',
                color: currentPage === totalPages ? '#6c757d' : 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                transition: 'all 0.3s'
              }}
            >
              Sonraki
              <i className="fas fa-chevron-right" style={{ marginLeft: '8px' }}></i>
            </button>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default LogsPage;